import React, { useEffect } from 'react'

const VideoLightbox = ({ src, poster, onClose, onPrev, onNext, caption }: {
	src: string; poster: string; onClose: () => void; onPrev?: () => void; onNext?: () => void; caption: string
}) => {
	useEffect(() => {
		const handleKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose()
			if (e.key === 'ArrowLeft' && onPrev) onPrev()
			if (e.key === 'ArrowRight' && onNext) onNext()
		}
		window.addEventListener('keydown', handleKey)
		return () => window.removeEventListener('keydown', handleKey)
	}, [onClose, onPrev, onNext])

	return (
		<div
			onClick={onClose}
			style={{
				position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
				backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 10000,
				display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'
			}}
		>
			{/* Toolbar – matches .ril__toolbar */}
			<div
				onClick={(e) => e.stopPropagation()}
				style={{
					position: 'absolute', top: 0, left: 0, right: 0, height: '50px',
					backgroundColor: 'rgba(0,0,0,0.5)',
					display: 'flex', justifyContent: 'space-between', zIndex: 1
				}}
			>
				<div />
				<div style={{ display: 'flex', alignItems: 'center', paddingRight: '20px' }}>
					<a
						href={src}
						download
						onClick={(e) => e.stopPropagation()}
						style={{
							width: '40px', height: '35px', cursor: 'pointer',
							opacity: 0.7, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
							background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTEwIDF2MTJtMCAwbC00LTRtNCA0bDQtNE0zIDE1djJoMTR2LTIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=') no-repeat center"
						}}
						onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
						onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
					/>
					<button
						onClick={onClose}
						style={{
							width: '40px', height: '35px', cursor: 'pointer', border: 'none',
							opacity: 0.7, backgroundColor: 'transparent',
							background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=') no-repeat center"
						}}
						onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
						onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
					/>
				</div>
			</div>

			<video
				onClick={(e) => e.stopPropagation()}
				controls
				autoPlay
				playsInline
				preload="metadata"
				poster={poster}
				style={{ maxWidth: '90vw', maxHeight: '80vh' }}
			>
				<source src={src} />
			</video>

			{/* Caption – matches .ril__caption */}
			<div
				onClick={(e) => e.stopPropagation()}
				style={{
					position: 'absolute', bottom: 0, left: 0, right: 0,
					backgroundColor: 'rgba(0,0,0,0.5)',
					display: 'flex', justifyContent: 'space-between'
				}}
			>
				<div style={{ padding: '10px 20px', color: '#fff' }}>{caption}</div>
			</div>

			{onPrev && (
				<button onClick={(e) => { e.stopPropagation(); onPrev() }} style={{
					position: 'absolute', left: 0, top: 0, bottom: 0, width: '20px',
					padding: '40px 30px', margin: 'auto', height: '34px',
					cursor: 'pointer', border: 'none', opacity: 0.7,
					background: "rgba(0,0,0,0.2) url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==') no-repeat center"
				}} onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')} onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')} />
			)}
			{onNext && (
				<button onClick={(e) => { e.stopPropagation(); onNext() }} style={{
					position: 'absolute', right: 0, top: 0, bottom: 0, width: '20px',
					padding: '40px 30px', margin: 'auto', height: '34px',
					cursor: 'pointer', border: 'none', opacity: 0.7,
					background: "rgba(0,0,0,0.2) url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+') no-repeat center"
				}} onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')} onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')} />
			)}
		</div>
	)
}

export default VideoLightbox
